import { ecommerceApi } from '@/redux/api/ecommerceApi'
import type { ECommerceApiGetProductsAndBrandsFromTheBraderyRequest } from '@itsrever/rever-api'
import { skipToken, useQuery } from '@tanstack/react-query'

export const useProductsBrands = ({
    orderNumber,
    email,
    ecommerceId
}: ECommerceApiGetProductsAndBrandsFromTheBraderyRequest & {
    ecommerceId?: string
}) => {
    return useQuery({
        queryKey: ['products-brands', orderNumber, email, ecommerceId],
        queryFn:
            orderNumber && email && ecommerceId
                ? async () => {
                      const { data } =
                          await ecommerceApi.getProductsAndBrandsFromTheBradery(
                              {
                                  email,
                                  orderNumber
                              }
                          )
                      return data
                  }
                : skipToken,
        staleTime: Infinity,
        retry: false
    })
}
